import React, { useContext, useEffect } from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { useParams } from 'react-router-dom';

import { getRedirectUrl, RedirectFromESMProps } from './redirect-from-esm-api';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';
import { AuthCtx } from 'components/auth/auth-ctx';

export const useStyles = makeStyles({
  loader: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 200,
  },
});

export const RedirectFromESM: React.FC = () => {
  const classes = useStyles();
  const { redirectFrom, id } = useParams<RedirectFromESMProps>();
  const { showNotification } = useContext(NotificationCtx);
  const { userInfo } = useContext(AuthCtx);

  useEffect(() => {
    async function load() {
      const { entityId, redirectUrl } = await getRedirectUrl(redirectFrom, id);

      if (entityId !== '') {
        window.location.href = `${window.location.origin}/badatelna/${redirectUrl}/${entityId}`;
      } else {
        showNotification(
          'Při přesměrování nastala chyba.',
          NotificationVariant.ERROR
        );
      }
    }

    if (!userInfo) {
      window.location.href = `${window.location.origin}/badatelna/registrace`;
    } else {
      load();
    }
  }, [id, redirectFrom, showNotification, userInfo]);

  return (
    <div className={classes.loader}>
      <CircularProgress />
    </div>
  );
};
